var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search",
    clipPath: "url(#clip0_5491_41516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0482 14.0962L18 17.0473L17.0248 18.0225L14.0737 15.0707C12.9757 15.9509 11.6099 16.4297 10.2026 16.4277C6.77877 16.4277 4 13.6489 4 10.2251C4 6.80123 6.77877 4.02246 10.2026 4.02246C13.6265 4.02246 16.4052 6.80123 16.4052 10.2251C16.4072 11.6324 15.9285 12.9982 15.0482 14.0962ZM13.6657 13.5848C14.5404 12.6854 15.0289 11.4797 15.0269 10.2251C15.0269 7.55933 12.8677 5.40082 10.2026 5.40082C7.53687 5.40082 5.37836 7.55933 5.37836 10.2251C5.37836 12.8901 7.53687 15.0493 10.2026 15.0493C11.4572 15.0513 12.6629 14.5629 13.5624 13.6882L13.6657 13.5848Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5491_41516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.0224609)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.a44d6bc36cbcc55c50cb8c494f999993.svg";
export { ForwardRef as ReactComponent };